import { AuthenticatedHttpService } from './HttpService';
import { firestoreDocumentById, executeQuery } from '../firebase/firestore';

export class KitapoService extends AuthenticatedHttpService {
  constructor() {
    super();
    this.httpClient = this.prepareHttpClient(process.env.VUE_APP_KITAPO_URL);
  }

  assembleKitapoAnalysis(analysis) {
    const kitapoAnalysis = {
      document: {
        title: analysis.documentDetails.title,
        description: analysis.documentDetails.excerpt,
        url: analysis.documentDetails.url,
        datePublished: extractDate(analysis.documentDetails.datePublished)
          || extractDate(analysis.documentDetails.date_published),
        image_url: extractImageUrl(analysis.documentDetails),
        id: extractDocumentId(analysis),
        source_id: extractSourceId(analysis.documentDetails),
        content_type: extractContentType(analysis.documentDetails),
      },
      acl: analysis.acl,
      id: extractAnalysisId(analysis),
      tags: analysis.tags,
    };
    console.log('assembled kitapo analysis', kitapoAnalysis);
    return kitapoAnalysis;
  }

  async saveAnalysis(analysis) {
    console.log('KitapoService saveAnalysis', analysis);
    const kitapoAnalysis = this.assembleKitapoAnalysis(analysis);

    const response = await (await this.httpClient).post('/analysis', kitapoAnalysis);
    // TODO: Make sure the analysis is available through the noos assistant search engine.
    // Should be done in the backend.
    await new Promise(resolve => setTimeout(resolve, 1000));
    return response.data;
  }

  async saveAnalysisV2(portfolioIds, analysis) {
    console.log('KitapoService save analysis v2', analysis);
    const payload = {
      analysis: this.assembleKitapoAnalysis(analysis),
      portfolio_ids: portfolioIds,
    };

    const response = await (await this.httpClient).post('/analysis/v2', payload);
    // TODO: Make sure the analysis is available through the noos assistant search engine.
    // Should be done in the backend.
    await new Promise(resolve => setTimeout(resolve, 1000));
    return response.data;
  }

  async addToPortfolio(portfolioId, analysisId) {
    console.log('KitapoService addToPortfolio', portfolioId, analysisId);
    const response = await (await this.httpClient).post(`/portfolio/${portfolioId}`, {
      analysisId,
    });
    console.log('addToPortfolio response', response);
    return response.data;
  }

  async removeFromPortfolio(portfolioId, analysisId) {
    console.log('KitapoService removeToPortfolio', portfolioId, analysisId);
    const response = await (await this.httpClient).delete(`/portfolio/${portfolioId}/analysis/${analysisId}`);
    console.log('removeFromPortfolio response', response);
    return response.data;
  }

  async fetchReflectionTemplates() {
    const client = await this.httpClient;
    const response = await client.get('/reflection_templates');
    return response.data;
  }

  async fetchAllReflections() {
    const client = await this.httpClient;
    const response = await client.get('/reflections');
    return response.data;
  }
}

export const addAnalysisMetadataOnDocument = async (doc) => {
  const documentData = { ...doc };
  documentData.documentDetails.tags = [];

  if (documentData.documentDetails.analysisId) {
    const { analysisId } = documentData.documentDetails;
    const analysis = await executeQuery(firestoreDocumentById('analyses', analysisId));

    if (analysis.tags && analysis.tags.length > 0) {
      documentData.documentDetails.tags = analysis.tags;
    }

    documentData.documentDetails.acl = analysis.acl;
    documentData.documentDetails.leadImageUrl = analysis.documentDetails.leadImageUrl;
    documentData.documentDetails.isUpload = analysis.documentDetails.isUpload;

    if (analysis.summary) {
      documentData.documentDetails.documentScore = analysis.summary.evaluationAverage;
      documentData.documentDetails.activityCount = analysis.summary.activityCount;
    }
  }

  return documentData;
};

const extractAnalysisId = (analysis) => {
  if (analysis.documentDetails.analysisId) return analysis.documentDetails.analysisId;
  if (analysis.id) return analysis.id;

  throw Error(`There is no analysis id for analysis ${analysis}`);
};

const extractDocumentId = (analysis) => {
  if (analysis.documentDetails.id) return analysis.documentDetails.id;
  if (analysis.documentId) return analysis.documentId;

  throw Error(`There is no document id for analysis ${analysis}`);
};

const extractContentType = (documentDetails) => {
  if (documentDetails.content_type) return documentDetails.content_type;
  if (documentDetails.contentType) return documentDetails.contentType;

  return 'text/html';
};

const extractSourceId = (documentDetails) => {
  if (documentDetails.sourceId) return documentDetails.sourceId;
  if (documentDetails.source_id) return documentDetails.source_id;

  throw Error(`There is no source id for document ${documentDetails}`);
};

const extractDate = (date) => {
  if (date) {
    return new Date(date).toISOString();
  }

  return undefined;
};

const extractImageUrl = (documentDetails) => {
  if (documentDetails.leadImageUrl && documentDetails.leadImageUrl !== '') {
    return documentDetails.leadImageUrl;
  }

  return null;
};

let instance;
export default () => {
  if (instance === undefined) {
    instance = new KitapoService();
  }

  return instance;
};
